
import React, { Component } from 'react';
import AdminReadyButton from 'components/AdminReadyButton';
import strings from 'strings';
import { getNonwordRepetition } from 'constants/tests';
import { updateStepData } from 'api';

const NW_STAGES = {
  INTRO: 0,
  TRIAL: 1,
  WAITING_POST_TRIAL: 2,
  TEST: 3,
  WAITING: 4,
};

const TRIAL_ITEMS_COUNT = 1;
const DELAY_SECONDS = 15; // must match Test.js delay


class NonwordRepetitionAdmin extends Component {
  constructor(props) {
    super(props);

    const spec = getNonwordRepetition(
      this.props.testKeyType,
      this.props.ageGroup
    );

	this.trialItems =
	 (spec && spec.getTrialSteps(this.props.testKeyType, this.props.ageGroup)) ||
      [];
    this.testItems =
      (spec && spec.getNonwordSteps(this.props.testKeyType, this.props.ageGroup)) ||
      [];

    this.state = {
      currentStage: props.currentStage || NW_STAGES.INTRO,
      currentStep: props.currentStep || 0,

      activePhase: 'immediate', // 'immediate' | 'delayed'

   
      results: {},
	  trialResults: {},

	    delayActive: false,
  		delayRemaining: 0, // seconds
    };

    this.rootEl = null;
	this.delayTimer = null; // handle for setInterval
  }

  componentDidMount() {
    if (this.rootEl) this.rootEl.focus();
  }

  componentDidUpdate(prevProps) {
  // keep stage/step in sync with roomConfig coming from TestAdmin
  if (
    prevProps.currentStage !== this.props.currentStage ||
    prevProps.currentStep !== this.props.currentStep
  ) {
    // New item or stage → reset admin delay timer
    if (this.delayTimer) {
      clearInterval(this.delayTimer);
      this.delayTimer = null;
    }

    this.setState({
      currentStage: this.props.currentStage,
      currentStep: this.props.currentStep,
      activePhase: 'immediate',
      delayActive: false,
      delayRemaining: 0,
    });
  }
}

componentWillUnmount() {
  if (this.delayTimer) {
    clearInterval(this.delayTimer);
  }
}

  codeToScore = (code) => (code === 'A' ? 1 : 0);

    setTrialScore = (phase, code) => {
    this.setState((prev) => {
      const { currentStep,currentStage } = prev;
      const prevItem = prev.trialResults[currentStep] || {};
	    
	  const isFirstImmediate =
      currentStage === NW_STAGES.TRIAL &&
      phase === 'immediate' &&
      (!prevItem.immediate || !prevItem.immediate.code);

    if (isFirstImmediate) {
      // tell candidate to start 15s distraction, and show admin timer
      updateStepData({ nonwordImmediateDone: true });
      this.startDelayTimer();
    }
      const newPhaseObj = {
        code,
        score: this.codeToScore(code),
      };
      const merged = {
        ...prevItem,
        [phase]: newPhaseObj,
      };
      const tot =
        (merged.immediate ? merged.immediate.score : 0) +
        (merged.delayed ? merged.delayed.score : 0);

      return {
        trialResults: {
          ...prev.trialResults,
          [currentStep]: { ...merged, total: tot },
        },
        activePhase: phase,
      };
    });
  };

  hasBothTrialAnswers = (idx) => {
    const item = this.state.trialResults[idx];
    return item && item.immediate && item.delayed;
  };

  goNextTrialItem = () => {
    const { currentStep } = this.state;
    const isLast = currentStep >= TRIAL_ITEMS_COUNT - 1;

    if (isLast) {
      // finished all 3 øvingsoppgaver → go to pause / test
      this.props.nextStage();
    } else {

      this.props.nextStep();
    }
  };


  setScore = (phase, code) => {
    this.setState((prev) => {
      const { currentStep,currentStage } = prev;
      const prevItem = prev.results[currentStep] || {};


    const isFirstImmediate =
      currentStage === NW_STAGES.TEST &&
      phase === 'immediate' &&
      (!prevItem.immediate || !prevItem.immediate.code);

    // side-effect: tell the server/candidate that immediate has been scored
    if (isFirstImmediate) {
		this.startDelayTimer();
      updateStepData({ nonwordImmediateDone: true });
    }


      const newPhaseObj = {
        code,
        score: this.codeToScore(code),
      };
      const merged = {
        ...prevItem,
        [phase]: newPhaseObj,
      };
      const tot =
        (merged.immediate ? merged.immediate.score : 0) +
        (merged.delayed ? merged.delayed.score : 0);

      return {
        results: {
          ...prev.results,
          [currentStep]: { ...merged, total: tot },
        },
        activePhase: phase,
      };
    });
  };

  hasBothAnswers = (idx) => {
    const item = this.state.results[idx];
    return item && item.immediate && item.delayed;
  };

    startDelayTimer = () => {
    // only used in TEST stage
    if (this.delayTimer) {
      clearInterval(this.delayTimer);
    }

    this.setState({
      delayActive: true,
      delayRemaining: DELAY_SECONDS,
    });

    this.delayTimer = setInterval(() => {
      this.setState((prev) => {
        const next = prev.delayRemaining - 1;
        if (next <= 0) {
          if (this.delayTimer) {
            clearInterval(this.delayTimer);
            this.delayTimer = null;
          }
          return {
            delayRemaining: 0,
            delayActive: false,
          };
        }
        return { delayRemaining: next };
      });
    }, 1000);
  };

  stopDelayTimer = () => {
    if (this.delayTimer) {
      clearInterval(this.delayTimer);
      this.delayTimer = null;
    }
    this.setState({
      delayActive: false,
      delayRemaining: 0,
    });
  };



  goNextItem = () => {

    this.props.nextStep(this.state.results);
  };

  // ---------- hotkeys ----------

  handleKeyDown = (e) => {
    const key = (e.key || '').toLowerCase();
    const { currentStage, activePhase } = this.state;

    const isTrial = currentStage === NW_STAGES.TRIAL;
    const isTest = currentStage === NW_STAGES.TEST;

    // Only react to keys in trial or test stage.
    if (!isTrial && !isTest) return;

    const setScoreFn = isTrial ? this.setTrialScore : this.setScore;
    const hasBothFn = isTrial ? this.hasBothTrialAnswers : this.hasBothAnswers;
    const goNextFn = isTrial ? this.goNextTrialItem : this.goNextItem;

    // A/S/D score on the active phase (immediate or delayed).
    if (key === 'a') {
      setScoreFn(activePhase, 'A');
      return;
    }
    if (key === 's') {
      setScoreFn(activePhase, 'S');
      return;
    }
    if (key === 'd') {
      setScoreFn(activePhase, 'D');
      return;
    }

    // 1 / 2 switch focus between immediate and delayed
    if (key === '1') {
      this.setState({ activePhase: 'immediate' });
      return;
    }
    if (key === '2') {
      this.setState({ activePhase: 'delayed' });
      return;
    }

    // Enter = next item (if both answers are scored)
    if (key === 'enter') {
      const { currentStep } = this.state;
      if (hasBothFn(currentStep)) {
        goNextFn();
      }
    }
  };



  renderIntro = () => (
    <>
      <p>
        {strings.nonword_admin_intro_1 ||
          'I denne oppgaven hører eleven nonord som ikke betyr noe. Eleven skal gjenta ordet rett etter et pling, og så én gang til etter 15 sekunder.'}
        <br />
        {strings.nonword_admin_intro_2 ||
          'Du skal lytte til elevens svar og skåre hvert svar som Riktig, Husker ikke eller Feil på testoppgavene.'}
      </p>

      <p>
        {strings.nonword_admin_intro_3 ||
          'På øvingsoppgavene kan stimulusordet gjentas ved behov (inntil tre ganger). Øvingsoppgavene skåres ikke.'}
      </p>

      <AdminReadyButton
        isPractiseTasks
        remoteIsReady={this.props.candidateReady}
        onClick={this.props.nextStep}
      />
    </>
  );

renderTrial = () => {
  const {
    currentStep,
    activePhase,
    trialResults,
    delayActive,
    delayRemaining,
  } = this.state;

    const items = this.trialItems || [];
    const total = items.length;
    const word = items[currentStep] || '';

    const itemRes = trialResults[currentStep] || {};
    const imm = itemRes.immediate || {};
    const del = itemRes.delayed || {};
    const bothAnswered = this.hasBothTrialAnswers(currentStep);

    return (
      <div>
        <p>
          {strings.nonword_admin_trial_1 ||
            'Nå gjennomføres øvingsoppgavene. La eleven høre nonordet og gjenta det to ganger – først rett etter pling, og så én gang til etter 15 sekunder.'}
          <br />
          {strings.nonword_admin_trial_2 ||
            'Du kan bruke de samme knappene som på testoppgavene (Riktig / Husker ikke / Feil) for å øve på skåringen. Øvingsoppgavene blir ikke lagret i resultatene.'}
        </p>
		
		<div className="sm-expected">
          <strong>{strings.stimulusWordLabel || 'Stimulusord'}:</strong>{' '}
          <span className="sm-expected__text">{word}</span>
        </div>

        <p className="sm-step-progress">
          {strings.formatString(
            strings.trialTaskNumOf || 'Øvingsoppgave {0} av {1}',
            currentStep + 1,
            total
          )}
        </p>

        <div className="nw-admin-sections">
          {/* Immediate repetition */}
          <div
            className={
              'nw-admin-section ' +
              (activePhase === 'immediate' ? 'nw-admin-section--active' : '')
            }
          >
            <h3>
              {strings.nonword_immediate ||
                '1. Umiddelbar repetisjon (rett etter pling)'}
            </h3>
            <div className="nw-admin-buttons">
              <button
                type="button"
                className={
                  'sm-btn ' + (imm.code === 'A' ? 'sm-btn--primary' : '')
                }
                onClick={() => this.setTrialScore('immediate', 'A')}
              >
                {strings.correct || 'Riktig'} (A)
              </button>
              <button
                type="button"
                className={
                  'sm-btn ' + (imm.code === 'S' ? 'sm-btn--primary' : '')
                }
                onClick={() => this.setTrialScore('immediate', 'S')}
              >
                {strings.notAnswered || 'Ikke besvart'} (S)
              </button>
              <button
                type="button"
                className={
                  'sm-btn ' + (imm.code === 'D' ? 'sm-btn--primary' : '')
                }
                onClick={() => this.setTrialScore('immediate', 'D')}
              >
                {strings.wrong || 'Feil'} (D)
              </button>
            </div>
            <p className="sm-hotkeys">
              {strings.nonword_hotkeys_immediate ||
                'Aktiv del: Umiddelbar repetisjon. Bruk tastene A, S, D for å skåre.'}
            </p>
          </div>

          {/* Delayed repetition */}
          <div
            className={
              'nw-admin-section ' +
              (activePhase === 'delayed' ? 'nw-admin-section--active' : '')
            }
          >
              <h3 className="nw-admin-heading">
    <span>
      {strings.nonword_delayed ||
        '2. Utsatt repetisjon (etter 15 sekunder)'}
    </span>

    {delayActive && (
      <span className="nw-admin-delay-pill">
        ⏱ {delayRemaining}s
      </span>
    )}
  </h3>
            <div className="nw-admin-buttons">
              <button
                type="button"
                className={
                  'sm-btn ' + (del.code === 'A' ? 'sm-btn--primary' : '')
                }
                onClick={() => this.setTrialScore('delayed', 'A')}
              >
                {strings.correct || 'Riktig'} (A)
              </button>
              <button
                type="button"
                className={
                  'sm-btn ' + (del.code === 'S' ? 'sm-btn--primary' : '')
                }
                onClick={() => this.setTrialScore('delayed', 'S')}
              >
                {strings.notAnswered || 'Ikke besvart'} (S)
              </button>
              <button
                type="button"
                className={
                  'sm-btn ' + (del.code === 'D' ? 'sm-btn--primary' : '')
                }
                onClick={() => this.setTrialScore('delayed', 'D')}
              >
                {strings.wrong || 'Feil'} (D)
              </button>
            </div>
            <p className="sm-hotkeys">
              {strings.nonword_hotkeys_delayed ||
                'Trykk 1 for å fokusere på umiddelbar repetisjon, 2 for utsatt. Bruk A, S, D for å skåre den aktive delen.'}
            </p>
          </div>
        </div>

        <div className="nw-admin-footer">
          <div className="nw-admin-total">
            {strings.nonword_item_total || 'Poeng for oppgaven'}:{' '}
            {(itemRes.total != null ? itemRes.total : 0) + ' / 2'}{' '}
            {strings.nonword_trial_note ||
              '(øvingsoppgave – skåren lagres ikke)'}
          </div>

          <button
            type="button"
            className="sm-btn sm-btn--primary"
            disabled={!bothAnswered}
            onClick={this.goNextTrialItem}
          >
            {currentStep + 1 < total
              ? strings.nextTrialTask || 'Neste øvingsoppgave'
              : strings.startTest || 'Start testoppgavene'}
          </button>
        </div>

        <p className="sm-hotkeys">
          <kbd>A</kbd>, <kbd>S</kbd>, <kbd>D</kbd>{' '}
          {strings.nonword_hotkeys_common ||
            'skårer den aktive delen (umiddelbar/utsatt).'}{' '}
          <kbd>1</kbd>/<kbd>2</kbd> –{' '}
          {strings.nonword_hotkeys_switch ||
            'bytt mellom umiddelbar og utsatt repetisjon.'}{' '}
          <kbd>Enter</kbd> –{' '}
          {strings.nonword_trial_hotkeys_next ||
            'bekreft øvingsoppgaven og gå videre'}
        </p>
      </div>
    );
  };


  renderWaitingPostTrial = () => (
    <div>
      <p>
        {strings.nonword_admin_wait_post_trial ||
          'Gi eleven en kort pause. Når dere er klare, starter du testoppgavene.'}
      </p>
      <button
        className="sm-btn sm-btn--primary"
        type="button"
        onClick={this.props.nextStage}
      >
        {strings.start || 'Start'}
      </button>
    </div>
  );

  renderTest = () => {
    const { currentStep, activePhase, results, delayActive, delayRemaining } =
  this.state;

    const items = this.testItems || [];
    const total = items.length;
    const word = items[currentStep] || '';

    const itemRes = results[currentStep] || {};
    const imm = itemRes.immediate || {};
    const del = itemRes.delayed || {};

    const bothAnswered = this.hasBothAnswers(currentStep);

    return (
      <div>
        <p>
          {strings.nonword_admin_test_info_1 ||
            'Eleven hører hvert nonord én gang. Etter første pling gjentar eleven ordet (umiddelbar repetisjon). Etter 15 sekunder kommer et nytt pling, og eleven gjentar ordet på nytt (utsatt repetisjon).'}
          <br />
          {strings.nonword_admin_test_info_2 ||
            'Du skårer begge svarene. A = Riktig (1 poeng), S = Husker ikke (0 poeng), D = Feil (0 poeng). Maks skår per oppgave er 2 poeng.'}
        </p>

        <p className="sm-step-progress">
          {strings.formatString(
            strings.taskNumOf || 'Oppgave {0} av {1}',
            currentStep + 1,
            total
          )}
        </p>

        <div className="sm-expected">
          <strong>{strings.stimulusWordLabel || 'Stimulusord'}:</strong>{' '}
          <span className="sm-expected__text">{word}</span>
        </div>

        <div className="nw-admin-sections">
          {/* Immediate repetition */}
          <div
            className={
              'nw-admin-section ' +
              (activePhase === 'immediate' ? 'nw-admin-section--active' : '')
            }
          >
            <h3>
              {strings.nonword_immediate ||
                '1. Umiddelbar repetisjon (rett etter pling)'}
            </h3>
            <div className="nw-admin-buttons">
              <button
                type="button"
                className={
                  'sm-btn ' + (imm.code === 'A' ? 'sm-btn--primary' : '')
                }
                onClick={() => this.setScore('immediate', 'A')}
              >
                {strings.correct || 'Riktig'} (A)
              </button>
              <button
                type="button"
                className={
                  'sm-btn ' + (imm.code === 'S' ? 'sm-btn--primary' : '')
                }
                onClick={() => this.setScore('immediate', 'S')}
              >
                {strings.notAnswered || 'Ikke besvart'} (S)
              </button>
              <button
                type="button"
                className={
                  'sm-btn ' + (imm.code === 'D' ? 'sm-btn--primary' : '')
                }
                onClick={() => this.setScore('immediate', 'D')}
              >
                {strings.wrong || 'Feil'} (D)
              </button>
            </div>
            <p className="sm-hotkeys">
              {strings.nonword_hotkeys_immediate ||
                'Aktiv del: Umiddelbar repetisjon. Bruk tastene A, S, D for å skåre.'}
            </p>
          </div>

          {/* Delayed repetition */}
          <div
            className={
              'nw-admin-section ' +
              (activePhase === 'delayed' ? 'nw-admin-section--active' : '')
            }
          >
               <h3 className="nw-admin-heading">
    <span>
      {strings.nonword_delayed ||
        '2. Utsatt repetisjon (etter 15 sekunder)'}
    </span>

    {delayActive && (
      <span className="nw-admin-delay-pill">
        ⏱ {delayRemaining}s
      </span>
    )}
  </h3>
            <div className="nw-admin-buttons">
              <button
                type="button"
                className={
                  'sm-btn ' + (del.code === 'A' ? 'sm-btn--primary' : '')
                }
                onClick={() => this.setScore('delayed', 'A')}
              >
                {strings.correct || 'Riktig'} (A)
              </button>
              <button
                type="button"
                className={
                  'sm-btn ' + (del.code === 'S' ? 'sm-btn--primary' : '')
                }
                onClick={() => this.setScore('delayed', 'S')}
              >
                {strings.notAnswered || 'Ikke besvart'} (S)
              </button>
              <button
                type="button"
                className={
                  'sm-btn ' + (del.code === 'D' ? 'sm-btn--primary' : '')
                }
                onClick={() => this.setScore('delayed', 'D')}
              >
                {strings.wrong || 'Feil'} (D)
              </button>
            </div>
            <p className="sm-hotkeys">
              {strings.nonword_hotkeys_delayed ||
                'Trykk 1 for å fokusere på umiddelbar repetisjon, 2 for utsatt. Bruk A, S, D for å skåre den aktive delen.'}
            </p>
          </div>
        </div>

        <div className="nw-admin-footer">
          <div className="nw-admin-total">
            {strings.nonword_item_total || 'Poeng for oppgaven'}:{' '}
            {(itemRes.total != null ? itemRes.total : 0) + ' / 2'}
          </div>

          <button
            type="button"
            className="sm-btn sm-btn--primary"
            disabled={!bothAnswered}
            onClick={this.goNextItem}
          >
            {strings.nextTask || 'Neste oppgave'}
          </button>
        </div>

        <p className="sm-hotkeys">
          <kbd>A</kbd>, <kbd>S</kbd>, <kbd>D</kbd>{' '}
          {strings.nonword_hotkeys_common ||
            'skårer den aktive delen (umiddelbar/utsatt).'}{' '}
          <kbd>1</kbd>/<kbd>2</kbd> –{' '}
          {strings.nonword_hotkeys_switch ||
            'bytt mellom umiddelbar og utsatt repetisjon.'}{' '}
          <kbd>Enter</kbd> – {strings.confirmAndNext || 'bekreft og gå videre'}
        </p>
      </div>
    );
  };

  renderWaiting = () => (
    <div>
      <p>
        {strings.formatString(
          strings.testDone || 'Testen {0} er ferdig.',
          strings.nonword_testname || 'Nonordrepetisjon'
        )}
      </p>
      {/* <button
        type="button"
        className="sm-btn sm-btn--primary"
        onClick={() => this.props.submitResults(this.state.results)}
      >
        {strings.submitResults || 'Lagre resultater'}
      </button> */}
      <button
        type="button"
        className="sm-btn sm-btn--ghost"
        onClick={this.props.nextStage}
      >
        {strings.nextTest || 'Neste deltest'}
      </button>
    </div>
  );

  // ---------- main render ----------

  render() {
    const { currentStage } = this.state;

    return (
      <div
        className="lit-intro NonwordRepetitionAdmin"
        tabIndex={0}
        ref={(el) => (this.rootEl = el)}
        onKeyDown={this.handleKeyDown}
      >
        <h1 className="lit-page-title">
          {strings.nonword_testname || 'Nonordrepetisjon'}
        </h1>

        {currentStage === NW_STAGES.INTRO && this.renderIntro()}
        {currentStage === NW_STAGES.TRIAL && this.renderTrial()}
        {currentStage === NW_STAGES.WAITING_POST_TRIAL &&
          this.renderWaitingPostTrial()}
        {currentStage === NW_STAGES.TEST && this.renderTest()}
        {currentStage === NW_STAGES.WAITING && this.renderWaiting()}
      </div>
    );
  }
}

export default NonwordRepetitionAdmin;
